"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACTIVE_COMPOSITE_ITEM = void 0;
const ACTIVE_COMPOSITE_ITEM = exports.ACTIVE_COMPOSITE_ITEM = 'data-composite-item-active';